module.exports = __webpack_public_path__ + "static/media/NPG for agenda.2fb710dc.svg";